import PropTypes from 'prop-types'
import React from 'react'
import {format} from 'ag-common/facades'
import FeedbackDownloadButton from '#components/m/Feedback/FeedbackDownloadButton'
import FeedbackUserDisplayField from '#components/m/Feedback/FeedbackUserDisplayField'
import FeedbackTitle from '#components/m/Feedback/FeedbackTitle'

export function FeedbackRowAsFachausbilder({feedback, downloadFile}) {
  const {concerningAzubi, uploadDate} = feedback
  const formattedUploadDate = format(new Date(uploadDate), 'dd. MMMM yyyy')

  return (
    <tr data-testid="feedback-row">
      <td>
        <div>
          <FeedbackUserDisplayField user={concerningAzubi} />
        </div>
      </td>
      <td>
        <div>
          <FeedbackTitle originalFilename={feedback.originalFilename} />
        </div>
      </td>
      <td>
        <div>
          <span>{formattedUploadDate}</span>
        </div>
      </td>
      <td>
        <FeedbackDownloadButton feedback={feedback} downloadFile={downloadFile} />
      </td>
    </tr>
  )
}

FeedbackRowAsFachausbilder.propTypes = {
  feedback: PropTypes.shape({
    id: PropTypes.string,
    concerningAzubi: PropTypes.shape({
      firstname: PropTypes.string,
      lastname: PropTypes.string,
      id: PropTypes.number,
      hasErrors: PropTypes.bool,
    }),
    originalFilename: PropTypes.string,
    uploadDate: PropTypes.any,
  }),
  downloadFile: PropTypes.func.isRequired,
}
